import React from "react";

import InfoTooltip from "@components/tooltip/info-tooltip";
import { classNames } from "@helpers/css";

export type Field = {
  title: string;
  tooltip?: string;
  render: () => React.ReactNode;
  id?: string;
  error?: string;
};

const FormFields = ({
  fields,
  width = 200,
}: {
  fields: Field[];
  width?: number;
}) => {
  return (
    <div className="flex flex-col gap-4">
      {fields.map((field) => (
        <div
          key={field.title}
          id={field.id}
          className={classNames(
            "flex items-baseline scroll-mt-24",
            field.error && "-mx-2 px-2 py-2 rounded-md bg-red-50",
          )}
        >
          <div
            className={classNames(
              "text-sm shrink-0 flex items-center justify-between mr-4",
              field.error ? "text-red-700 font-medium" : "text-gray-600",
            )}
            style={{ width: `${width}px` }}
          >
            <div>{field.title}</div>
            {field.tooltip && <InfoTooltip text={field.tooltip} />}
          </div>
          <div className="flex-1">
            {field.render()}
            {field.error && (
              <div className="mt-1 text-xs text-red-600">{field.error}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FormFields;
